import { Badge, Button, Col, DatePicker, Form, Input, Popover, Row, Select, Space } from 'antd';
import GenericTable from '../../../components/Commons/Table/generic-table.component';
import ShowDataLength from '../../../components/Commons/Table/results-length-table.component';
import { useEffect, useState } from 'react';
import { PaginationProps } from 'antd/lib';
import { FilterValue } from 'antd/es/table/interface';
import { useQuery } from 'react-query';
import { cutLongText, downloadExcel, formatCurrency, formatCurrencyToExport } from '../../../services/utils';
import { RangePickerProps } from 'antd/es/date-picker';
import ExportBtn from '../../../components/Commons/Export/ExportButton';
import { getAll as loadServices } from '../../../services/bookingServices.service';
import moment from 'moment';
import Title from 'antd/es/typography/Title';
import { getWorkerById } from '../../../services/reports.service';
import { isMobile } from 'react-device-detect';
import FilterButton from '../../../components/Commons/Table/FilterButton';
import dayjs from 'dayjs';

const { Search } = Input;

export default function Details(props: any) {
    const [services, setServices] = useState([]);
    const [currentPage, setCurrentPage] = useState<number | undefined>(1);
    const [perPage, setPerPage] = useState<number | undefined>(10);
    const [year, setYear] = useState<number>(new Date().getFullYear());
    const [total, setTotal] = useState<number>(0);
    const [totalValue, setTotalValue] = useState<number>(0);
    const [search, setSearch] = useState<string>('');
    const [startDate, setStartDate] = useState<string>(dayjs().format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState<string>(dayjs().format('YYYY-MM-DD'));    
    const [order, setOrder] = useState<string>('start-asc');
    const [formSearch] = Form.useForm();
    const [servicesToExport, setServicesToExport] = useState([]);
    const [exportIsLoading, setExportIsLoading] = useState<boolean>(false);
    const [worker, setWorker] = useState<any>();
    const [openFilters, setOpenFilters] = useState<boolean>(false);
    const [formFilter] = Form.useForm();

    useQuery(
        ['loadWorker', props.id, year],
        () => getWorkerById(Number(props.id), `?byMonth=1&year=${year}`),
        {
            onSuccess: (response: any) => {
                if (response) {
                    setWorker(response?.data);

                    if (props.type !== 'staff') {
                        setServices(
                            (response?.data?.byMonth || [])
                                .map((row: any, index: number) => {
                                    return {
                                        key: index,
                                        ...row
                                    }
                                })
                        );
                        setTotal(response?.data?.byMonth?.length || 0);
                        setTotalValue(
                            (response?.data?.byMonth || [])
                                .reduce((total: number, record: any) => total += (record?.value || 0), 0)
                        );
                    }
                }
            },
            refetchOnWindowFocus: false
        }
    );

    const {
        isLoading: getServicesLoading
    } = useQuery(
        ['loadData', currentPage, search, order, perPage, startDate, endDate],
        () => {
            if (props.type === 'staff') {
                return loadServices({
                    page: currentPage, per_page: perPage,
                    order, search, start_date: startDate, end_date: endDate, onlyWorkerType: props.type,
                    staff_id: props.type === 'staff' ? Number(props.id) : undefined,
                    supplier_id: props.type === 'suppliers' ? Number(props.id) : undefined,
                    service_state: 'Fechado',
                });
            }

            return [];
        },
        {
            onSuccess: (response: any) => {
                if (props.type === 'staff') {

                    setServices(response.data.map((record: any) => {
                        return {
                            key: record.data.id,
                            ...record.data,
                            ...record.relationships
                        }
                    }));

                    setTotalValue(response.meta.total_value_table);
                    setServicesToExport([]);
                    setCurrentPage(response.meta.current_page);
                    setPerPage(response.meta.per_page);
                    setTotal(response.meta.total);
                }
            },
            refetchOnWindowFocus: false
        }
    );

    const { refetch: loadservicesToExport } = useQuery(
        ['loadservicesToExport', search, order, startDate, endDate],
        () => {
            if (props.type === 'staff') {
                return loadServices({
                    order, search, start_date: startDate, end_date: endDate, onlyWorkerType: props.type,
                    staff_id: props.type === 'staff' ? Number(props.id) : undefined,
                    supplier_id: props.type === 'suppliers' ? Number(props.id) : undefined
                });
            } else {
                return getWorkerById(Number(props.id), `?byMonth=1&year=${year}`);
            }
        },
        {
            onSuccess: response => {
                if (props.type === 'staff') {
                    setServicesToExport(onMapDataToExport(response.data));
                } else {
                    setServicesToExport(onMapDataToExport(response?.data?.byMonth || []));
                }
            },
            refetchOnWindowFocus: false,
            enabled: false
        }
    );

    const onSearch = (search_value: any) => {
        setCurrentPage(1);
        setSearch(search_value);
    };

    const onFilter = () => {
        setCurrentPage(1);
        let start_date = formFilter.getFieldValue('filter_start_date');
        let end_date = formFilter.getFieldValue('filter_end_date');

        setStartDate(start_date ? start_date.format('YYYY-MM-DD') : '');
        setEndDate(end_date ? end_date.format('YYYY-MM-DD') : '');
    };

    const onClearFilters = () => {
        setCurrentPage(1);
        setStartDate('');
        setEndDate('');
    };

    const disabledStartDate: RangePickerProps['disabledDate'] = (current) => {
        let endDate = formFilter.getFieldValue('filter_end_date');

        if (endDate) {
            return current >= endDate;
        }

        return false;
    };

    const disabledEndDate: RangePickerProps['disabledDate'] = (current) => {
        let startDate = formFilter.getFieldValue('filter_start_date');

        if (startDate) {
            return current <= startDate;
        }

        return false;
    };

    const handleTableChange = (
        pagination: PaginationProps,
        filters: Record<string, FilterValue | null>,
        sorter: any
    ) => {
        if (pagination.current !== currentPage) {
            setCurrentPage(pagination.current);
        }

        if (pagination.pageSize !== perPage) {
            setPerPage(pagination.pageSize);
            setCurrentPage(1);
        }

        if (sorter.order) {
            let orderBy = `${sorter.field}-${sorter.order.substr(0, sorter.order.length - 3)}`;

            if (order !== orderBy) {
                setOrder(orderBy);
            }
        }
    };

    const calculateStaffValue = (record: any) => {
        if (record.charge === 'driver') {
            return record.amount_charged || record.value || 0;
        }

        let route = record?.staff?.relationships?.table?.relationships
            ?.routes?.find((route: any) =>
                route.from_zone_id == record?.pickup_zone_id
                && route.to_zone_id == record?.dropoff_zone_id
            );

        if (route) {
            let totalNumberOfPeople = (record?.number_adults || 0) + (record?.number_children || 0);

            let value = totalNumberOfPeople <= 4
                ? route?.pax14
                : (totalNumberOfPeople <= 8
                    ? route?.pax58
                    : 0);

            return value;
        }

        return 0;
    };

    const onMapDataToExport = (data: any) => {
        let total = 0;

        const dados = data.map((service: any) => {

            if (props.type === 'staff') {

                total += service.data.value_table;

                return {
                    'Data': service?.data?.start ? moment(service.data.start, 'YYYY-MM-DD').format('DD/MM/YYYY') : '',
                    'Pick-up': service.data.pickup_location,
                    'Drop-off': service.data.dropoff_location,
                    'Valor a receber': formatCurrencyToExport(service.data.value_table),
                };

            }

            total += (service.value || 0);

            return {
                'Mês': service?.month,
                [props.type === 'suppliers'
                    ? 'N° de Reservas'
                    : 'N° de Serviços']: service?.quantity,
                'Valor a receber': formatCurrencyToExport(service.value || 0),
            };
        });

        if (props.type === 'staff') {
            return dados.concat([{
                'Data': '',
                'Pick-up': '',
                'Drop-off': 'TOTAL',
                'Valor a receber': formatCurrencyToExport(total)
            }]);
        }

        return dados.concat([{
            'Mês': '',
            [props.type === 'suppliers'
                ? 'N° de Reservas'
                : 'N° de Serviços']: 'TOTAL',
            'Valor a receber': formatCurrencyToExport(total)
        }]);
    };

    const exportData = () => downloadExcel(servicesToExport, `Controle-Relatório-${props.label}`);

    const years = () => {
        let startYear = 2024;
        const currentYear = new Date().getFullYear();
        const years = [];

        while (startYear <= currentYear) {
            years.push({
                value: startYear,
                label: startYear
            });

            startYear++;
        }

        return years;
    }

    const columnsOperator = [
        { title: 'Mês', dataIndex: 'month', key: 'month' },
        { title: 'N° de Reservas', dataIndex: 'quantity', sorter: false, key: 'quantity', width: 150 },
        {
            title: 'Valor a receber', dataIndex: 'value', key: 'value', width: 180,
            render: (_: any, record: any) => record?.value ? formatCurrency(record?.value) : 0
        },
    ];

    const columnsSupplier = [
        { title: 'Mês', dataIndex: 'month', key: 'month' },
        { title: 'N° de Serviços', dataIndex: 'quantity', sorter: false, key: 'quantity', width: 150 },
        {
            title: 'Valor a receber', dataIndex: 'value', key: 'value', width: 180,
            render: (_: any, record: any) => record?.value ? formatCurrency(record?.value) : 0
        },
    ];

    const columnsStaff = [
        {
            title: 'Data', dataIndex: 'start', key: 'start', sorter: true, width: 130,
            render: (_: any, record: any) => record.start ? moment(record.start, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
        },
        {
            title: 'Pick-up', dataIndex: 'pickup_location', key: 'pickup_location',
            render: (_: any, record: any) => (cutLongText(record?.pickup_location, 20)),
        },
        {
            title: 'Drop-off', dataIndex: 'dropoff_location', key: 'dropoff_location',
            render: (_: any, record: any) => (cutLongText(record?.dropoff_location, 20)),
        },
        {
            title: 'Tipo de serviço', dataIndex: ['serviceType', 'data', 'name'], key: 'serviceType',
            render: (_: any, record: any) => (<Badge color={record?.serviceType?.data?.color} text={record?.serviceType?.data?.name} styles={{ indicator: { width: 12, height: 12 } }} />)
        },
        { title: 'Nome do cliente', dataIndex: ['booking', 'data', 'client_name'], key: 'client_name' },
        {
            title: 'Valor a receber', dataIndex: 'value', key: 'value', sorter: true, width: 180,
            render: (_: any, record: any) => formatCurrency(record?.value_table)
        },
    ];

    const handleOpenFiltersChange = (open: boolean) => {
        setOpenFilters(open);
    };

    const filters = (
        <Form
            form={formFilter}
            name="filter_services"
            layout="vertical"
            className="form_filter_horizontal"
            style={{ width: 300 }}
            autoComplete="off">
            <Row>
                {props.type === 'staff' ? <>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }}>
                        <Form.Item name="filter_start_date" label="Data início" className='item_filter'>
                            <DatePicker size="large" placeholder="dd/mm/aaaa" format={"DD/MM/YYYY"}
                                style={{ width: '100%' }} disabledDate={disabledStartDate} />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }}>
                        <Form.Item name="filter_end_date" label="Data fim" className='item_filter'>
                            <DatePicker size="large" placeholder="dd/mm/aaaa" format={"DD/MM/YYYY"}
                                style={{ width: '100%' }} disabledDate={disabledEndDate} />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }}>
                        <Button onClick={onFilter} size="large">Filtrar</Button>

                        {(startDate || endDate)
                            && <Button type="link" onClick={onClearFilters} size="large">Limpar</Button>
                        }
                    </Col>
                </>
                    : <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }}>
                        <Form.Item label="Ano" name="filter_year" className="item_filter">
                            <Select value={year} style={isMobile ? {} : { width: 200 }} size="large"
                                options={years()} onChange={(value) => setYear(value)} />
                        </Form.Item>
                    </Col>
                }
            </Row>
        </Form>
    );

    useEffect(() => {
        if (props.type === 'staff') {
            formFilter.setFieldsValue({
                filter_start_date: '',
                filter_end_date: '',
                [props.workerFilter]: ''
            });
        } else {
            formFilter.setFieldValue('filter_year', '');
        }
    }, []);

    useEffect(() => {
        if (props.type === 'staff') {
            if (!startDate) {
                formFilter.setFieldValue('filter_start_date', '');
            }

            if (!endDate) {
                formFilter.setFieldValue('filter_end_date', '');
            }
        } else {
            formFilter.setFieldValue('filter_year', year);
        }
    }, [startDate, endDate, year]);

    useEffect(() => {
        if (servicesToExport.length) {
            exportData();
        }

        setExportIsLoading(false);
    }, [servicesToExport]);

    return (
        <>
            {props.type === 'staff' &&
                <div>
                    <Row className="search_bar">
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                            <Form
                                form={formSearch}
                                name="search_tables"
                                className="form_search_horizontal"
                                autoComplete="off">

                                <Form.Item name="search_table" className={!isMobile ? "item_search" : "item_search_mobile"}>
                                    <Search onSearch={onSearch} placeholder="Pesquisa por local de pick-up ou drop-off" enterButton="Pesquisar" allowClear size="large" maxLength={255} />
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                </div >
            }

            <div className="table">
                <GenericTable
                    columns={
                        props.type === 'staff'
                            ? columnsStaff
                            : (props.type === 'suppliers'
                                ? columnsSupplier
                                : columnsOperator)
                    }
                    dataSource={services}
                    pagination={props.type === 'staff' ? {
                        current: currentPage,
                        pageSize: perPage,
                        showSizeChanger: true,
                        total: total
                    } : undefined}
                    loading={getServicesLoading}
                    totalChildren={
                        <div className="zone_result_size_n_export" style={isMobile ? { marginTop: 10 } : {}}>
                            <Space direction='vertical' className="show_result_size">
                                <Title level={4} style={{ fontWeight: 700, float: 'left' }}>{worker?.name}</Title>

                                {props.type === 'staff' && <ShowDataLength size={total} />}
                            </Space>

                            <Space direction={isMobile ? 'vertical' : 'horizontal'} className="show_result_size">
                                <Form.Item label="Valor total do período" className='item_filter'
                                    style={isMobile ? { width: 100 } : { width: 230 }}>
                                    <Input placeholder='Selecione um periodo' readOnly value={formatCurrency(totalValue)} />
                                </Form.Item>

                                <FilterButton filters={filters} />

                                <ExportBtn disabled={!total} loading={exportIsLoading}
                                    onClick={() => {
                                        if (servicesToExport.length) {
                                            exportData();
                                        } else {
                                            setExportIsLoading(true);
                                            loadservicesToExport();
                                        }
                                    }} />
                            </Space>
                        </div>
                    }
                    empty={{
                        createTheFirst: !services.length && !search && !startDate && !endDate,
                        textOne: !services.length && !search && !startDate && !endDate
                            ? 'Nenhum dado a ser exibido.'
                            : 'Não há resultados para a combinação de filtros selecionada.',
                        textTwo: !services.length && !search && !startDate && !endDate
                            ? ''
                            : 'Tente novamente com diferentes valores de filtro.',
                        link: '',
                        createText: ''
                    }}
                    handleTableChange={handleTableChange}
                    scroll={isMobile ? { x: 800 } : undefined}
                />
            </div>
        </>
    );
}